var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeguimientosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    fill: "none",
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#003049",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M5.879 17.382v-2.07M11 17.382v-4.14m5.121 4.14v-6.22m-.002-6.08-.46.54a18.882 18.882 0 0 1-9.78 6.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#003049",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.191 5.082h2.93v2.92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#003049",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 21.232h6c5 0 7-2 7-7v-6c0-5-2-7-7-7H8c-5 0-7 2-7 7v6c0 5 2 7 7 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguimientosIcon);
export default __webpack_public_path__ + "static/media/seguimientosIcon.e3eadbcb52f9861004b26d8aa9a21671.svg";
export { ForwardRef as ReactComponent };